/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import * as urlHelpers from 'Helpers/url';

const useLegacyRouterHooks = ({
    onEnter,
    onLeave,
    onChange,
    config,
    asyncComponentLoader,
    component,
    params,
    location
}) => {
    const navigate = useNavigate();
    const onChangeRef = useRef(false);

    const replace = path => {
        navigate(path, { replace: true });
    };

    const nextState = {
        location: {
            ...location,
            query: location.search ? urlHelpers.queryStringToParams(location.search.substring(1)) : {},
            search: location.search || ''
        },
        params
    };

    useEffect(() => {
        if (onEnter) {
            onEnter(nextState, replace, config);
        }

        if (onChangeRef.current) {
            if (onChange) {
                onChange(nextState, replace, config);
            }
        }
        else {
            onChangeRef.current = true;
        }

        if (asyncComponentLoader && typeof window !== 'undefined') {
            asyncComponentLoader(component);
        }

        return () => {
            if (onLeave) {
                onLeave(nextState, replace, config);
            }
        };
    }, [location.pathname]);
};

export default useLegacyRouterHooks;
